const fromRefcode = (state) => state.auth.fromRefcode

const isAuthorized = (state) => state.auth.isAuthorized
const accessToken = (state) => state.auth.accessToken

const loginStatus = (state) => state.auth.loginStatus
const signupStatus = (state) => state.auth.signupStatus
const forgotStatus = (state) => state.auth.forgotStatus
const resetStatus = (state) => state.auth.resetStatus
const checkOtpStatus = (state) => state.auth.checkOtpStatus // Added for OTP check status

export default {
  fromRefcode,

  isAuthorized,
  accessToken,

  loginStatus,
  signupStatus,
  forgotStatus,
  resetStatus,
  checkOtpStatus, // Exporting the OTP check status selector
}